<template>
  <div class="curativeBody">
    <div class="curativeContainer">
      <div class="curativeItem" v-for="(item, index) in curativeConfig" :key="index + item.label">
        <auth-img class="iconImg" :src="calcSatusImg(item, index)" alt="" />
        <div class="label">{{ item.label }}</div>
      </div>
    </div>
    <a-divider v-if="isEvlatued" />
    <div class="curativeRes" v-if="isEvlatued">
      {{ curativeConfig[activeIndex]?.activeMsg }}
    </div>

    <div
      class="afterCurative"
      v-if="
        EvalutedStatus !== 0 && [1, 2, 3].includes(activeIndex) && props.isGroup !== 0 && isEvlatued
      "
    >
      <div class="giveLike">
        <img :src="giveLike" alt="" />
      </div>
      <div class="btnBox">
        <div class="presentBanner"><img :src="presentBanner" alt="" /></div>
        <div><img :src="thanksLetter" alt="" /></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import presentBanner from '@/assets/img/chat/present-banner.png'
import thanksLetter from '@/assets/img/chat/thanks-letter.png'
import giveLike from '@/assets/img/chat/give-like.png'
import { CurativeTypes } from './config'
const props = defineProps({
  trackConfig: {
    type: Object,
    default: () => {}
  },
  eventCode: {
    type: String,
    default: () => {}
  },
  isGroup: {
    type: Boolean,
    default: false
  }
})
const curativeConfig = CurativeTypes
const { customEvent = '29301', flowResultStatus } = props.trackConfig || {}
// 已评价结果
const EvalutedStatus = computed(() => Number(flowResultStatus))
// 29301 疗效跟踪待评价 29302 疗效跟踪已评价
const isEvlatued = computed(() =>
  customEvent ? customEvent !== '29301' : props.eventCode !== '29301'
)
// // 评价对应 Config Index
const activeIndex = curativeConfig.findIndex(item => item.status === Number(EvalutedStatus.value))

const calcSatusImg = (ctx, ctxIndex) => {
  if (!isEvlatued.value) {
    return ctx.activeIcon
  } else {
    return ctx.status === EvalutedStatus.value ? ctx.activeIcon : ctx.icon
  }
}
</script>

<style lang="scss" scoped>
.curativeBody {
  width: 100%;

  .curativeContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .curativeItem {
      width: 51px;
      height: 68px;
      background: #f9f9f9;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 9px 6px;

      .iconImg {
        width: 28px;
        height: 28px;
      }

      .label {
        font-weight: 400;
        font-size: 14px;
        color: #1a1a1a;
        margin-top: 4px;
      }
    }
  }

  .curativeRes {
    font-weight: 400;
    font-size: 14px;
    color: #3b3b3b;
  }

  ::v-deep(.ant-divider-horizontal) {
    margin: 12px 0;
  }

  .afterCurative {
    margin-top: 10px;
    img {
      width: 100%;
    }
    .giveLike {
      margin-bottom: 12px;
    }
    .btnBox {
      display: flex;
      justify-content: space-between;
      .presentBanner {
        margin-right: 8px;
      }
    }
  }
}
</style>
